import { useEffect } from "react";
import { useMapEvents } from "react-leaflet";

import { IMapLocationTracker } from "../../../LocationInfo/types";
import { useConfig } from "../../../../Settings/useConfig";
import { MapLocationTrackingBehaviour } from "../../../../Settings/settingsTypes";


interface MapLocationTrackingProps {
    locationTracker: IMapLocationTracker;
}

const MapLocationTracking = (props: MapLocationTrackingProps): JSX.Element => {

    const config = useConfig();

    const isTrackingActive = props.locationTracker.isTrackingActive;
    const location = props.locationTracker.location;
    const behaviour = props.locationTracker.locationTrackingBehaviour;

    const handleDragStart = () => {
        if (behaviour === MapLocationTrackingBehaviour.TurnOffOnPan && isTrackingActive) {
            props.locationTracker.toggleTracking();
        }
    };

    const map = useMapEvents({
        dragstart: handleDragStart
    });

    useEffect(() => {
        
        if (isTrackingActive === true && location && config.maxBounds.contains(location.point)) {
            map.panTo(location.point);
        }

    }, [map, isTrackingActive, location, config.maxBounds]);

    return <></>;
};

export default MapLocationTracking;